module.exports = __webpack_public_path__ + "img/air-img1.5385a74c.png";